
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13 2c1.645 0 3 1.355 3 3v3.563l7.625 1.656A3.019 3.019 0 0126 13.157v16.844H10v-5.594l-6.719-6.781L3 17.313v-.406c0-1.616 1.23-2.908 2.656-2.906 1.336 0 2.327.468 2.969.938.401.294.469.422.625.625l.75.188V5.002c0-1.645 1.355-3 3-3zm0 2c-.565 0-1 .435-1 1v13.344l-1.25-.313-2.25-.594-.406-.125-.188-.344s-.084-.179-.438-.438-.91-.531-1.813-.531c-.308 0-.481.172-.563.594l6.313 6.406h12.594v-9.844c0-.477-.314-.9-.781-1l-8.438-1.781-.781-.188V4.998c0-.565-.435-1-1-1zm-1 21v3h12v-3H12z"}})])
          )
        }
      }
    